import {ListItem, ListItemProps} from '@genestack/ui';
import React from 'react';

import {Link} from 'wouter';

import styles from './document-nodes.module.css';

export interface DocumentNode {
    id: string;
    label: string;
}

interface Props {
    docAccession: string;
    documentNode: DocumentNode;
    nodeProps?: ListItemProps;
    getDocumentLink: (documentId: string, nodeId?: string) => string;
}

export const DocumentNodeItem = ({
    docAccession,
    documentNode,
    getDocumentLink,
    nodeProps = {}
}: Props) => {
    const illegalProps = {
        as: Link,
        to: getDocumentLink(docAccession, documentNode.id),
        ...nodeProps
    };

    return (
        <ListItem
            titleContentProps={{className: styles.nodeTitle}}
            contentProps={{className: styles.nodeContent}}
            interactive
            title={documentNode.label}
            {...illegalProps}
            onClick={nodeProps.onClick}
        >
            {documentNode.label}
        </ListItem>
    );
};
